const ComparisonTable = ({ tableData }) => {
  return (
    <div className="w-full overflow-x-scroll sm:overflow-x-auto">
      {tableData?.heading && (
        <h2 className="text-2xl font-bold mb-4">{tableData?.heading}</h2>
      )}
      {tableData?.subHeading && (
        <p className="text-lg mb-4">{tableData?.subHeading}</p>
      )}
      <div className="w-[500px] sm:w-full bg-white">
        <thead>
          <tr>
            {tableData?.headers?.map((header, index) => (
              <th
                key={index}
                className="py-2 px-4 bg-gray-200 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData?.rows?.map((row, index) => (
            <tr key={index} className="text-sm">
              <td className="py-2 px-4 border-b border-r border-gray-200 font-semibold">
                {row?.feature}
              </td>
              <td className="py-2 px-4 border-b border-r border-gray-200">
                {row?.product1}
              </td>
              <td className="py-2 px-4 border-b border-r border-gray-200">
                {row?.product2}
              </td>
              {
                row?.product3 && (
                  <td className="py-2 px-4 border-b border-r border-gray-200">
                    {row?.product3}
                  </td>
                )
              }
            </tr>
          ))}
        </tbody>
      </div>
      {tableData?.paragraph && (
        <p className="text-lg mt-4">{tableData?.paragraph}</p>
      )}
    </div>
  );
};

export default ComparisonTable;
